// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Receivables dialogs of an invoice (Rechnungskorrektur, send checklist, payment, Storno,
   Rechnungsberichtigung, write-off). Modals are portaled, so every rule is scoped under the
   modal's rootClassName .invoice-dialog; the chain and payment list live in .invoice-details-page.
   Phones get bottom sheets from design-system/responsive.css. Logical properties only (RTL). */

.invoice-dialog .invoice-dialog__body {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  min-width: 0;
}

.invoice-dialog .invoice-dialog__body .ant-form-item {
  margin-bottom: var(--ds-space-3);
}

.invoice-dialog .invoice-dialog__body h5.ant-typography {
  margin: 0 0 var(--ds-space-2);
}

.invoice-dialog .invoice-dialog__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.invoice-dialog .invoice-dialog__section-head h5.ant-typography {
  margin: 0;
}

.invoice-dialog .invoice-dialog__hint {
  display: block;
  font-size: 12px;
  margin-bottom: var(--ds-space-2);
}

.invoice-dialog .invoice-dialog__list {
  margin: 0;
  padding-inline-start: var(--ds-space-4);
}

.invoice-dialog .invoice-dialog__meta {
  display: block;
  font-size: 12px;
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

/* Original lines: text and quantity input side by side, stacked on phones */
.invoice-dialog .invoice-dialog__line {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(120px, 160px);
  gap: var(--ds-space-3);
  align-items: start;
  padding-block: var(--ds-space-2);
  border-bottom: 1px solid var(--ds-border-soft);
}

.invoice-dialog .invoice-dialog__line-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.invoice-dialog .invoice-dialog__line-input {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: end;
}

/* Free lines and correction-notice rows: a card with a field grid */
.invoice-dialog .invoice-dialog__free,
.invoice-dialog .invoice-dialog__notice-row {
  display: grid;
  gap: var(--ds-space-2);
  align-items: end;
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-2);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface-muted);
}

.invoice-dialog .invoice-dialog__free {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) auto;
}

.invoice-dialog .invoice-dialog__free-desc {
  grid-column: 1 / -1;
}

.invoice-dialog .invoice-dialog__notice-row {
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) auto;
}

.invoice-dialog .invoice-dialog__field {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
  min-width: 0;
  margin: 0;
}

.invoice-dialog .invoice-dialog__field > span {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.invoice-dialog .invoice-dialog__free-remove {
  min-width: 40px;
  min-height: 40px;
}

/* Totals */
.invoice-dialog .invoice-dialog__totals {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  padding-top: var(--ds-space-3);
  border-top: 1px solid var(--ds-border-soft);
}

.invoice-dialog .invoice-dialog__total-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  font-variant-numeric: tabular-nums;
}

.invoice-dialog .invoice-dialog__total-row--sum {
  font-size: 1rem;
}

/* Pflichtangaben checklist */
.invoice-dialog .invoice-dialog__checklist {
  list-style: none;
  margin: 0 0 var(--ds-space-3);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
}

.invoice-dialog .invoice-dialog__checklist li,
.invoice-dialog .invoice-dialog__checklist-ok {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-2);
  overflow-wrap: anywhere;
}

.invoice-dialog .invoice-dialog__checklist li .anticon,
.invoice-dialog .invoice-dialog__checklist-ok .anticon {
  margin-top: 3px;
}

.invoice-dialog .invoice-dialog__check--error {
  color: var(--ds-danger, #dc2626);
}

.invoice-dialog .invoice-dialog__check--warning {
  color: var(--ds-warning, #d97706);
}

.invoice-dialog .invoice-dialog__check--ok {
  color: var(--ds-success, #16a34a);
}

/* Customer credits to offset */
.invoice-dialog .invoice-dialog__credits {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  width: 100%;
  margin-bottom: var(--ds-space-3);
}

.invoice-dialog .invoice-dialog__credits .ant-checkbox-wrapper {
  width: 100%;
}

.invoice-dialog .invoice-dialog__credits .ant-checkbox-wrapper > span:last-child {
  flex: 1;
  min-width: 0;
}

.invoice-dialog .invoice-dialog__credit {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.invoice-dialog .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-inline-start: 0;
}

.invoice-dialog .invoice-dialog__body > .ant-checkbox-wrapper {
  margin-bottom: var(--ds-space-1);
}

@media (max-width: 767.98px) {
  .invoice-dialog .invoice-dialog__line {
    grid-template-columns: minmax(0, 1fr) minmax(96px, 120px);
  }

  .invoice-dialog .invoice-dialog__free {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .invoice-dialog .invoice-dialog__notice-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .invoice-dialog .invoice-dialog__free-remove {
    justify-self: end;
  }
}

/* ── Details page: sections, chain, payments ─────────────── */
.invoice-details-page .invoice-section {
  margin-top: var(--ds-space-5);
  padding-top: var(--ds-space-4);
  border-top: 1px solid var(--ds-border-soft);
}

.invoice-details-page .invoice-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
}

.invoice-details-page .invoice-section__head h5 {
  margin: 0;
}

.invoice-details-page .invoice-chain {
  margin-top: var(--ds-space-2);
}

.invoice-details-page .invoice-chain__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.invoice-details-page .invoice-chain__head {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.invoice-details-page .invoice-chain__title {
  font-weight: 600;
  overflow-wrap: anywhere;
}

.invoice-details-page .invoice-chain__amount,
.invoice-details-page .invoice-payments__amount {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.invoice-details-page .invoice-chain__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--ds-space-1) var(--ds-space-2);
}

.invoice-details-page .invoice-chain__meta .ant-tag {
  margin-inline-end: 0;
}

.invoice-details-page .invoice-chain__extra {
  font-size: 12px;
}

.invoice-details-page .invoice-alerts {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
}

.invoice-dialog .invoice-dialog__deduction {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2) var(--ds-space-3);
}

.invoice-dialog .invoice-dialog__deduction .ant-btn {
  white-space: normal;
  height: auto;
  min-height: 40px;
  text-align: start;
}

/* Print dialog: one language per row */
.invoice-dialog .invoice-dialog__languages {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
}
`, "",{"version":3,"sources":["webpack://./src/commons/Billing/Invoices/InvoiceDialogs.css"],"names":[],"mappings":"AAAA;;;+FAG+F;;AAE/F;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,0DAA0D;EAC1D,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA,oEAAoE;AACpE;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,uCAAuC;EACvC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,yDAAyD;EAC3D;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+DAA+D;AAC/D;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB","sourcesContent":["/* Receivables dialogs of an invoice (Rechnungskorrektur, send checklist, payment, Storno,\n   Rechnungsberichtigung, write-off). Modals are portaled, so every rule is scoped under the\n   modal's rootClassName .invoice-dialog; the chain and payment list live in .invoice-details-page.\n   Phones get bottom sheets from design-system/responsive.css. Logical properties only (RTL). */\n\n.invoice-dialog .invoice-dialog__body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  min-width: 0;\n}\n\n.invoice-dialog .invoice-dialog__body .ant-form-item {\n  margin-bottom: var(--ds-space-3);\n}\n\n.invoice-dialog .invoice-dialog__body h5.ant-typography {\n  margin: 0 0 var(--ds-space-2);\n}\n\n.invoice-dialog .invoice-dialog__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.invoice-dialog .invoice-dialog__section-head h5.ant-typography {\n  margin: 0;\n}\n\n.invoice-dialog .invoice-dialog__hint {\n  display: block;\n  font-size: 12px;\n  margin-bottom: var(--ds-space-2);\n}\n\n.invoice-dialog .invoice-dialog__list {\n  margin: 0;\n  padding-inline-start: var(--ds-space-4);\n}\n\n.invoice-dialog .invoice-dialog__meta {\n  display: block;\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n/* Original lines: text and quantity input side by side, stacked on phones */\n.invoice-dialog .invoice-dialog__line {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(120px, 160px);\n  gap: var(--ds-space-3);\n  align-items: start;\n  padding-block: var(--ds-space-2);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.invoice-dialog .invoice-dialog__line-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.invoice-dialog .invoice-dialog__line-input {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: end;\n}\n\n/* Free lines and correction-notice rows: a card with a field grid */\n.invoice-dialog .invoice-dialog__free,\n.invoice-dialog .invoice-dialog__notice-row {\n  display: grid;\n  gap: var(--ds-space-2);\n  align-items: end;\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-2);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface-muted);\n}\n\n.invoice-dialog .invoice-dialog__free {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) auto;\n}\n\n.invoice-dialog .invoice-dialog__free-desc {\n  grid-column: 1 / -1;\n}\n\n.invoice-dialog .invoice-dialog__notice-row {\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) auto;\n}\n\n.invoice-dialog .invoice-dialog__field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n  min-width: 0;\n  margin: 0;\n}\n\n.invoice-dialog .invoice-dialog__field > span {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.invoice-dialog .invoice-dialog__free-remove {\n  min-width: 40px;\n  min-height: 40px;\n}\n\n/* Totals */\n.invoice-dialog .invoice-dialog__totals {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  padding-top: var(--ds-space-3);\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.invoice-dialog .invoice-dialog__total-row {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  font-variant-numeric: tabular-nums;\n}\n\n.invoice-dialog .invoice-dialog__total-row--sum {\n  font-size: 1rem;\n}\n\n/* Pflichtangaben checklist */\n.invoice-dialog .invoice-dialog__checklist {\n  list-style: none;\n  margin: 0 0 var(--ds-space-3);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n}\n\n.invoice-dialog .invoice-dialog__checklist li,\n.invoice-dialog .invoice-dialog__checklist-ok {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--ds-space-2);\n  overflow-wrap: anywhere;\n}\n\n.invoice-dialog .invoice-dialog__checklist li .anticon,\n.invoice-dialog .invoice-dialog__checklist-ok .anticon {\n  margin-top: 3px;\n}\n\n.invoice-dialog .invoice-dialog__check--error {\n  color: var(--ds-danger, #dc2626);\n}\n\n.invoice-dialog .invoice-dialog__check--warning {\n  color: var(--ds-warning, #d97706);\n}\n\n.invoice-dialog .invoice-dialog__check--ok {\n  color: var(--ds-success, #16a34a);\n}\n\n/* Customer credits to offset */\n.invoice-dialog .invoice-dialog__credits {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  width: 100%;\n  margin-bottom: var(--ds-space-3);\n}\n\n.invoice-dialog .invoice-dialog__credits .ant-checkbox-wrapper {\n  width: 100%;\n}\n\n.invoice-dialog .invoice-dialog__credits .ant-checkbox-wrapper > span:last-child {\n  flex: 1;\n  min-width: 0;\n}\n\n.invoice-dialog .invoice-dialog__credit {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.invoice-dialog .ant-checkbox-wrapper + .ant-checkbox-wrapper {\n  margin-inline-start: 0;\n}\n\n.invoice-dialog .invoice-dialog__body > .ant-checkbox-wrapper {\n  margin-bottom: var(--ds-space-1);\n}\n\n@media (max-width: 767.98px) {\n  .invoice-dialog .invoice-dialog__line {\n    grid-template-columns: minmax(0, 1fr) minmax(96px, 120px);\n  }\n\n  .invoice-dialog .invoice-dialog__free {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .invoice-dialog .invoice-dialog__notice-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .invoice-dialog .invoice-dialog__free-remove {\n    justify-self: end;\n  }\n}\n\n/* ── Details page: sections, chain, payments ─────────────── */\n.invoice-details-page .invoice-section {\n  margin-top: var(--ds-space-5);\n  padding-top: var(--ds-space-4);\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.invoice-details-page .invoice-section__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n}\n\n.invoice-details-page .invoice-section__head h5 {\n  margin: 0;\n}\n\n.invoice-details-page .invoice-chain {\n  margin-top: var(--ds-space-2);\n}\n\n.invoice-details-page .invoice-chain__item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.invoice-details-page .invoice-chain__head {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.invoice-details-page .invoice-chain__title {\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.invoice-details-page .invoice-chain__amount,\n.invoice-details-page .invoice-payments__amount {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.invoice-details-page .invoice-chain__meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--ds-space-1) var(--ds-space-2);\n}\n\n.invoice-details-page .invoice-chain__meta .ant-tag {\n  margin-inline-end: 0;\n}\n\n.invoice-details-page .invoice-chain__extra {\n  font-size: 12px;\n}\n\n.invoice-details-page .invoice-alerts {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n}\n\n.invoice-dialog .invoice-dialog__deduction {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2) var(--ds-space-3);\n}\n\n.invoice-dialog .invoice-dialog__deduction .ant-btn {\n  white-space: normal;\n  height: auto;\n  min-height: 40px;\n  text-align: start;\n}\n\n/* Print dialog: one language per row */\n.invoice-dialog .invoice-dialog__languages {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
